<template>
	<ViewUiCalloutIcon
		class="view-ui-state-nodiagrams"
		iconFilename="rack-9ball.svg"
		v-bind:message="'There are no<br />diagrams yet'"
	/>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/State
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiStateNoDiagrams extends ViewBase {
		// Not implemented
	}
</script>

<style lang="scss">
	.view-ui-state-nodiagrams {
		aspect-ratio: auto;
		margin: 0;
	}
</style>
